import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UseCase } from '../../base';
import { LocationsRepository } from '../../repositories';

@Injectable({providedIn: 'root'})
export class ImportLocationsFromFileUsecase implements UseCase<FormData, boolean> {
  constructor(private locationRepository: LocationsRepository) {}

  execute(request: FormData): Observable<boolean> {
    return this.locationRepository.importLocationsFromFile(request);
  }
}